<div class="router-bar">
  <div class="route-button" [ngClass]="{'current-route': router.url === '/projects'}">
    <button mat-button [routerLink]="['/projects']">Projects</button>
  </div>
  <div class="route-button" [ngClass]="{'current-route': router.url === '/customers'}">
    <button mat-button [routerLink]="['/customers']">Customers</button>
  </div>
  <div class="route-button" [ngClass]="{'current-route': router.url === '/client-nfs'}">
    <button mat-button [routerLink]="['/client-nfs']">Client Nfs</button>
  </div>
</div>

<div class="nf-page-header">
	<div class="page-title">
		Client Notifications
	</div>
</div>


<div class="scroll-content">
	<div class="middle-block">
		<div class="nfs-blocks" *ngIf="!loadingg">
			<div class="nfs-block" *ngFor="let clientNf of clientNfs">
				<app-client-message [clientNf]="clientNf" [ngClass]="{'resolved-nfs': clientNf.resolvedTime}"
					[isMobile]="isMobile" [fromProj]="false" (dismissMsg)="dismissMsg($event)"
					(deleteMsg)="deleteMsg($event)"></app-client-message>
			</div>
			<div class="no-nfs-block" *ngIf="clientNfs.length === 0">
				No notifications
			</div>
		</div>

		<div class="nfs-blocks loading-block" *ngIf="loadingg">
			<lib-progress-spinner></lib-progress-spinner>
		</div>
	</div>
	<div class="footer-block">
		<p-paginator #orderPaginator [rows]="15" [totalRecords]="totalRecords"
			(onPageChange)="getNfsLazy($event.page, $event.rows)">
		</p-paginator>
	</div>
</div>
